import { parse } from "date-fns";
import { toZonedTime } from "date-fns-tz";

const toEndOfDayInLA = (dateStr: string) => {
  const localDate = parse(dateStr, "yyyy-MM-dd", new Date());

  localDate.setHours(23, 59, 59, 0);
  return toZonedTime(localDate, "America/Los_Angeles");
};

function calculateTimeLeft(endDateStr: string) {
  if (!endDateStr) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  let endDate: Date;

  if (endDateStr.length === 10) {
    const parsed = parse(endDateStr, "yyyy-MM-dd", new Date());
    parsed.setHours(23, 59, 59, 0);
    endDate = toZonedTime(parsed, "America/Los_Angeles");
  } else {
    endDate = new Date(endDateStr);
  }

  const now = new Date();
  const diff = endDate.getTime() - now.getTime();

  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

export default calculateTimeLeft;
